import { render, staticRenderFns } from "./frontBanner.vue?vue&type=template&id=864e6748&"
import script from "./frontBanner.vue?vue&type=script&lang=js&"
export * from "./frontBanner.vue?vue&type=script&lang=js&"
import style0 from "./frontBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports